// [ 수주서 > 기본정보 ] 수주정보 1
export const obtainDefaultInfo = [
    {
        label: "발행일",
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "프로젝트 코드",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "사내 견적번호",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "기업별 입찰번호",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
];
// [ 수주서 > 기본정보 ] 수주정보 2
export const obtainDefaultInfo2 = [
    {
        label: "납기",
        type: "dateSingle",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        disabled: true,
    },
    { label: "인도조건", col: "12", sm: "4", lg: "4", value: "", disabled: true },
    {
        label: "견적명",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "견적 기간",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "특이사항",
        col: "12",
        sm: "4",
        lg: "12",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
];
// [ 수주서 > 기본정보 ] 업체정보
export const obtainCompanyDefaultInfo = [
    {
        label: "업체명",
        column_name: "company_name",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "담당자",
        column_name: "company_manager",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "담당자 E-mail",
        column_name: "company_manager_email",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [
            (v) => !!v || "필수 입력",
            (v) => /.+@.+\..+/.test(v) || "이메일 형식 확인",
        ],
        disabled: true,
    },
    {
        label: "담당자 연락처",
        column_name: "company_manager_phone",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [
            (v) => !!v || "필수 입력",
            (v) => /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/.test(v) ||
                "번호 형식 확인(ex : 010-1234-5678)",
        ],
        disabled: true,
    },
];
export const obtainFilesDefaultInfo = [
    {
        label: "도면",
        column_name: "blueprint",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
    },
    {
        label: "승인서",
        column_name: "approval",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
    },
    {
        label: "수주서",
        column_name: "obtain",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
    },
    {
        label: "기타",
        column_name: "files",
        type: "file",
        col: "12",
        sm: "6",
        lg: "6",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
    },
];
// 노무비 산출 모달
export const labor_list_headers = [
    { text: "품번", align: "center", value: "no" },
    { text: "공종", align: "center", value: "name" },
    { text: "규격", align: "center", value: "type" },
    { text: "직종", align: "center", value: "occupation" },
    { text: "공량(M/D)", align: "center", value: "man_per_day" },
    { text: "할증율", align: "center", value: "surcharge_ratio" },
    { text: "설계조정률", align: "center", value: "adjustment_ratio" },
    { text: "공량(M/H)", align: "center", value: "man_per_hour" },
    { text: "단가(M/D)", align: "center", value: "unit_price" },
    { text: "수량", align: "center", value: "quantity" },
    { text: "금액", align: "center", value: "total_amount" },
    { text: "추가", align: "center", value: "" },
];
